<script setup lang="ts"></script>

<template>
    <div v-for="index in 3" :key="index" class="skeleton-container">
        <div class="skeleton">
            <div class="skeleton__grid">
                <SkeletonPartsImage aspect="1:1" />
                <div class="skeleton__content">
                    <SkeletonPartsText class="skeleton__title" />
                    <SkeletonPartsText class="skeleton__question" />
                    <SkeletonPartsText />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
//@import '../../node_modules/bootstrap-vue/src/components/skeleton/skeleton';
.skeleton-container {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 2em auto;
}
.skeleton {
    background-color: rgba(0, 0, 0, 0.12);
    cursor: wait;
    margin-bottom: 0.25rem;
    border-radius: 0.25rem;

    &__grid {
        display: grid;
        gap: 10px;

        @include screen-md {
            grid-template-columns: repeat(4, 1fr);
            padding: 15px 10px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @include screen-md {
            grid-column: span 3;
        }
    }

    &__title {
        height: 50px;
    }

    &__question {
        height: 100px;
    }
}
</style>
